/**
 * Sidebar Navigation Component
 *
 * Handles collapsible navigation behavior for sidebar menus.
 * On mobile: Acts as an accordion that opens/closes the entire menu.
 * On desktop: Allows expanding/collapsing individual sections.
 */
class SidebarNav extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.mobileTrigger = this.querySelector('.sidebar-nav__mobile-trigger');
    this.groupToggles = this.querySelectorAll('.sidebar-nav__toggle');

    this.bindEvents();
  }

  /**
   * Binds click events to toggle buttons
   */
  bindEvents() {
    if (this.mobileTrigger) {
      this.mobileTrigger.addEventListener('click', this.handleMobileToggle.bind(this));
    }

    this.groupToggles.forEach((toggle) => {
      toggle.addEventListener('click', this.handleGroupToggle.bind(this));
    });
  }

  /**
   * Handles mobile accordion toggle
   * @param {Event} event - Click event
   */
  handleMobileToggle(event) {
    event.preventDefault();
    const trigger = event.currentTarget;
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', !isExpanded);
  }

  /**
   * Handles individual group toggle
   * @param {Event} event - Click event
   */
  handleGroupToggle(event) {
    event.preventDefault();
    const toggle = event.currentTarget;
    const group = toggle.closest('.sidebar-nav__group');

    if (!group) return;

    const isExpanded = group.dataset.expanded === 'true';
    group.dataset.expanded = !isExpanded;
    toggle.setAttribute('aria-expanded', !isExpanded);
  }
}

if (!customElements.get('sidebar-nav')) {
  customElements.define('sidebar-nav', SidebarNav);
}
